import station from "./station.component";
import stationUrls from "./station.urls";
import StationTransforms from "./station.transforms";

const stationModule = angular
  .module("app.components.station", [])
  .component("stationPage", station)
  .service("StationTransforms", StationTransforms)
  .config(stationUrls);

export default stationModule;



// WEBPACK FOOTER //
// ./src/pages/station/station.module.js